var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnboardingStage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 903 905.822",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.275,
    cy: 0.184,
    r: 1.172,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#480fa8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b01632"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.287,
    cy: 0.089,
    r: 1.383,
    xlinkHref: "#radial-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26097",
    "data-name": "Group 26097",
    transform: "translate(-280 -2365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26096",
    "data-name": "Group 26096",
    transform: "translate(250.999 2364.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26076",
    "data-name": "Group 26076",
    transform: "translate(299.001 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_21",
    "data-name": "Union 21",
    d: "M33.343,872.765A112.865,112.865,0,1,1,192.956,713.148l-6.744,6.745,6.756-6.756a79.485,79.485,0,1,0,.024-112.433l.011.011A112.864,112.864,0,1,1,193,441.1l-4.287,4.288,4.3-4.3a79.483,79.483,0,1,0,0-112.407l-23.608-23.6a112.865,112.865,0,1,1,0,159.619l-.011.011a79.484,79.484,0,1,0-.026,112.433l-.013-.013a112.865,112.865,0,1,1,0,159.618l-.011.011a79.484,79.484,0,1,0-56.209,135.684l.008.021v-.043H362.49v33.388H113.152V905.8l-.008.027A112.516,112.516,0,0,1,33.343,872.765Zm.068-544.051A112.865,112.865,0,0,1,193.026,169.1l-23.6,23.6a79.484,79.484,0,1,0,0,112.408h0l23.6,23.6h0a112.866,112.866,0,0,1-159.615,0ZM169.534,192.672l23.6-23.606a79.485,79.485,0,1,0,56.21-135.685l-.006-.022V33.4H0V.015H249.34V.026L249.346,0a112.865,112.865,0,1,1-79.812,192.672Z",
    transform: "translate(0)",
    fill: "#fff",
    opacity: 0.146
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143600",
    "data-name": "Path 143600",
    d: "M924.535,810.046A60.444,60.444,0,1,1,864.089,749.6,60.443,60.443,0,0,1,924.535,810.046Z",
    transform: "translate(-751.033 -561.201)",
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 2,
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143601",
    "data-name": "Path 143601",
    d: "M1074.171,660.4a60.445,60.445,0,1,0-60.446-60.446A60.445,60.445,0,0,0,1074.171,660.4Z",
    transform: "translate(-824.937 -487.289)",
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 2,
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143705",
    "data-name": "Path 143705",
    d: "M1074.171,660.4a60.445,60.445,0,1,0-60.446-60.446A60.445,60.445,0,0,0,1074.171,660.4Z",
    transform: "translate(-824.937 -214.857)",
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 2,
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143706",
    "data-name": "Path 143706",
    d: "M1074.171,660.4a60.445,60.445,0,1,0-60.446-60.446A60.445,60.445,0,0,0,1074.171,660.4Z",
    transform: "translate(-824.937 55.671)",
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 2,
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143602",
    "data-name": "Path 143602",
    d: "M924.5,1230.146a60.445,60.445,0,1,1-60.445-60.445A60.444,60.444,0,0,1,924.5,1230.146Z",
    transform: "translate(-750.999 -708.951)",
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 2,
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143604",
    "data-name": "Path 143604",
    d: "M924.428,1650.313a60.445,60.445,0,1,1-60.445-60.445A60.444,60.444,0,0,1,924.428,1650.313Z",
    transform: "translate(-750.833 -857.354)",
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 2,
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26070",
    "data-name": "Group 26070",
    transform: "translate(221.284 91.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143606",
    "data-name": "Path 143606",
    d: "M1077.75,612.293c0,12.453-5.019,21-15.3,21-10.408,0-14.994-9.356-15.055-20.756,0-11.647,4.957-20.878,15.365-20.878C1073.537,591.662,1077.75,601.264,1077.75,612.293Zm-20.879.247c-.062,9.232,2.168,13.631,5.824,13.631s5.637-4.585,5.637-13.754c0-8.921-1.92-13.63-5.7-13.63C1059.163,598.786,1056.809,603.185,1056.871,612.54Z",
    transform: "translate(-1047.392 -591.662)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143607",
    "data-name": "Path 143607",
    d: "M1131.27,601.373h-.123l-7.683,3.655-1.549-7.063,10.657-4.957h7.806V633.28h-9.107Z",
    transform: "translate(-1084.244 -592.328)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26071",
    "data-name": "Group 26071",
    transform: "translate(85.109 230.182)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143608",
    "data-name": "Path 143608",
    d: "M861.77,819.991c0,11-4.432,18.546-13.513,18.546-9.191,0-13.24-8.261-13.294-18.328,0-10.285,4.377-18.436,13.568-18.436C858.05,801.773,861.77,810.253,861.77,819.991Zm-18.437.218c-.054,8.152,1.914,12.036,5.143,12.036s4.978-4.049,4.978-12.146c0-7.878-1.7-12.035-5.034-12.035C845.358,808.064,843.279,811.949,843.333,820.209Z",
    transform: "translate(-834.963 -801.773)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143609",
    "data-name": "Path 143609",
    d: "M904.217,837.935V832.9l4.6-4.158c7.768-6.948,11.543-10.942,11.653-15.1,0-2.9-1.751-5.2-5.854-5.2a12.886,12.886,0,0,0-7.6,2.954l-2.353-5.963a19.682,19.682,0,0,1,11.652-3.665c8.042,0,12.475,4.7,12.475,11.161,0,5.963-4.323,10.723-9.465,15.318l-3.283,2.735v.109h13.4v6.839Z",
    transform: "translate(-873.304 -801.773)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26072",
    "data-name": "Group 26072",
    transform: "translate(220.51 366.357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143610",
    "data-name": "Path 143610",
    d: "M1075.186,1030.364c0,11.213-4.52,18.913-13.781,18.913-9.372,0-13.5-8.425-13.556-18.69,0-10.488,4.464-18.8,13.836-18.8C1071.391,1011.786,1075.186,1020.433,1075.186,1030.364Zm-18.8.222c-.055,8.314,1.952,12.274,5.245,12.274s5.076-4.129,5.076-12.385c0-8.033-1.729-12.273-5.133-12.273C1058.449,1018.2,1056.329,1022.163,1056.385,1030.586Z",
    transform: "translate(-1047.849 -1011.786)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143611",
    "data-name": "Path 143611",
    d: "M1118.341,1040.35a20,20,0,0,0,8.424,2.231c4.408,0,6.639-2.12,6.639-4.854,0-3.57-3.57-5.188-7.309-5.188h-3.458v-6.081h3.291c2.845-.056,6.472-1.116,6.472-4.184,0-2.176-1.785-3.794-5.356-3.794a16.547,16.547,0,0,0-7.587,2.177l-1.729-6.138c2.175-1.395,6.527-2.733,11.213-2.733,7.755,0,12.051,4.072,12.051,9.038,0,3.849-2.176,6.862-6.638,8.424v.112c4.352.781,7.867,4.072,7.867,8.815,0,6.416-5.635,11.1-14.841,11.1a21.431,21.431,0,0,1-10.767-2.566Z",
    transform: "translate(-1085.312 -1011.786)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26073",
    "data-name": "Group 26073",
    transform: "translate(85.109 502.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143612",
    "data-name": "Path 143612",
    d: "M858.655,1239.819c0,10.831-4.365,18.268-13.311,18.268-9.053,0-13.041-8.137-13.095-18.053,0-10.13,4.311-18.16,13.364-18.16C854.991,1221.874,858.655,1230.226,858.655,1239.819Zm-18.161.215c-.054,8.03,1.886,11.856,5.066,11.856s4.9-3.988,4.9-11.963c0-7.759-1.671-11.855-4.958-11.855C842.489,1228.071,840.441,1231.9,840.495,1240.034Z",
    transform: "translate(-832.25 -1221.874)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143613",
    "data-name": "Path 143613",
    d: "M914.695,1258.248V1249.9h-15.52v-5.335l13.256-21.339h10.023v20.532h4.2v6.143h-4.2v8.352Zm0-14.5v-7.761c0-2.1.107-4.257.269-6.519h-.215c-1.133,2.263-2.048,4.311-3.234,6.519l-4.688,7.653v.108Z",
    transform: "translate(-869.75 -1222.629)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26074",
    "data-name": "Group 26074",
    transform: "translate(220.51 637.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143614",
    "data-name": "Path 143614",
    d: "M1072.378,1450.445c0,11.159-4.665,18.821-14.225,18.821-9.674,0-13.937-8.383-13.994-18.6,0-10.437,4.607-18.708,14.282-18.708C1068.462,1431.958,1072.378,1440.563,1072.378,1450.445Zm-19.407.222c-.058,8.273,2.015,12.215,5.413,12.215s5.24-4.109,5.24-12.325c0-7.994-1.786-12.213-5.3-12.213C1055.1,1438.343,1052.913,1442.284,1052.971,1450.666Z",
    transform: "translate(-1044.16 -1431.958)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143615",
    "data-name": "Path 143615",
    d: "M1138.406,1440.24h-14.512l-.806,5.549a16.756,16.756,0,0,1,2.418-.111,17.6,17.6,0,0,1,9.848,2.608c2.822,1.831,4.549,4.827,4.549,9.043,0,6.714-5.989,12.65-16.066,12.65a24.545,24.545,0,0,1-10.423-2.053l1.555-6.325a22.2,22.2,0,0,0,8.465,1.775c3.628,0,7.486-1.665,7.486-5.492,0-3.718-3.052-5.992-10.539-5.992a33.47,33.47,0,0,0-5.067.333l2.475-18.92h20.616Z",
    transform: "translate(-1082.997 -1432.672)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26075",
    "data-name": "Group 26075",
    transform: "translate(84.697 774.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143616",
    "data-name": "Path 143616",
    d: "M859.014,1660.068c0,10.883-4.386,18.354-13.374,18.354-9.1,0-13.1-8.176-13.157-18.138,0-10.178,4.332-18.245,13.427-18.245C855.332,1642.039,859.014,1650.43,859.014,1660.068Zm-18.247.216c-.054,8.068,1.895,11.912,5.09,11.912s4.926-4.007,4.926-12.02c0-7.8-1.678-11.911-4.982-11.911C842.771,1648.265,840.714,1652.109,840.768,1660.284Z",
    transform: "translate(-832.484 -1642.039)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143617",
    "data-name": "Path 143617",
    d: "M923.385,1648.573a22.563,22.563,0,0,0-3.195.109c-7.309.6-10.557,4.331-11.478,8.446h.163a9.912,9.912,0,0,1,7.471-2.815c5.9,0,10.883,4.169,10.883,11.478a12.6,12.6,0,0,1-12.995,12.724c-9.366,0-13.969-6.984-13.969-15.377,0-6.606,2.437-12.128,6.227-15.647,3.519-3.194,8.067-4.926,13.59-5.2a23.624,23.624,0,0,1,3.3-.054Zm-4.494,17.651c0-3.248-1.733-6.063-5.252-6.063a5.369,5.369,0,0,0-4.872,3.14,4.755,4.755,0,0,0-.325,2.057c.163,3.736,1.95,7.092,5.686,7.092C917.05,1672.45,918.891,1669.8,918.891,1666.223Z",
    transform: "translate(-870.323 -1642.13)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("text", {
    id: "Once_a_client_confirms_they_would_like_to_work_with_us_or_if_we_win_any_study_from_the_client_share_name_of_the_client_and_email_address_with_Knowledge_team_.",
    "data-name": "Once a client confirms they would like to work with us or if we win any study from the client, share name of the client and email address with Knowledge team\\u200B.",
    transform: "translate(933 2404.483)",
    fill: "#191817",
    fontSize: 14,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    letterSpacing: "0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "Once a client confirms they "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 39
  }, "would like to work with us or if "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 63
  }, "we win any study from the "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 87
  }, "client, share name of the client "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 111
  }, "and email address with "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 135
  }, "Knowledge team\u200B.")), /*#__PURE__*/React.createElement("text", {
    id: "The_KT_team_will_onboard_client_to_the_portal_and_the_client_will_receive_an_email_to_our_portal_where_they_will_be_able_to_fill_out_onboarding_form_SLA_And_NDA.",
    "data-name": "The KT team will onboard client to the portal and the client will receive an email to our portal where they will be able to fill out onboarding form, SLA And NDA.",
    transform: "translate(280 2553)",
    fill: "#191817",
    fontSize: 14,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    letterSpacing: "0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "The KT team will onboard client "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 39
  }, "to the portal and the client will "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 63
  }, "receive an email to our portal "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 87
  }, "where they will be able to fill out "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 111
  }, "onboarding form, SLA And NDA.")), /*#__PURE__*/React.createElement("text", {
    id: "Once_the_client_completes_onboarding_sales_team_is_informed_and_you_are_good_to_proceed_with_the_project_execution_",
    "data-name": "Once the client completes onboarding, sales team is informed, and you are good to proceed with the project execution\\u200B",
    transform: "translate(933 2700.647)",
    fill: "#191817",
    fontSize: 14,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    letterSpacing: "0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "Once the client completes "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 39
  }, "onboarding, sales team is "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 63
  }, "informed, and you are good to "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 87
  }, "proceed with the project "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 111
  }, "execution\u200B")), /*#__PURE__*/React.createElement("text", {
    id: "Remove_all_pricing_details_from_the_email_chain_and_loop_in_the_PM._The_PM_removes_salesperson_from_the_email_chain_from_the_second_email_onwards._",
    "data-name": "Remove all pricing details from the email chain and loop in the PM.\\u200B The PM removes salesperson from the email chain from the second email onwards. \\u200B",
    transform: "translate(933 2963.811)",
    fill: "#191817",
    fontSize: 14,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    letterSpacing: "0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "Remove all pricing details from "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 39
  }, "the email chain and loop in the "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 63
  }, "PM.\u200B"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 87
  }, "The PM removes salesperson "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 111
  }, "from the email chain from the "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 135
  }, "second email onwards. \u200B")), /*#__PURE__*/React.createElement("text", {
    id: "Thanks_client_for_the_business_and_loop_in_Client_services_team_to_the_email_chain_after_discussing_with_Amit._Amit_confirms_who_will_be_the_PM_internally_for_every_account._",
    "data-name": "Thanks, client, for the business and loop in Client services team to the email chain after discussing with Amit. \\u200B Amit confirms who will be the PM internally for every account. \\u200B",
    transform: "translate(280 2820)",
    fill: "#191817",
    fontSize: 14,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    letterSpacing: "0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "Thanks, client, for the business "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 39
  }, "and loop in Client services team "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 63
  }, "to the email chain after "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 87
  }, "discussing with Amit. \u200B"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 111
  }, "Amit confirms who will be the "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 135
  }, "PM internally for every account. \u200B")), /*#__PURE__*/React.createElement("text", {
    id: "Create_a_separate_email_chain_and_put_subject_as_Pricing_Study_name_._Send_the_quotation_table_to_finance_jaspercolin.com_",
    "data-name": "Create a separate email chain and put subject as \\u201CPricing | Study name\\u201D. Send the quotation table to finance@jaspercolin.com\\u200B",
    transform: "translate(280 3096)",
    fill: "#191817",
    fontSize: 14,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500,
    letterSpacing: "0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "Create a separate email chain "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 39
  }, "and put subject as \u201CPricing | "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 63
  }, "Study name\u201D. Send the "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 87
  }, "quotation table to "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 111
  }, "finance@jaspercolin.com\u200B")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingStage);
export default __webpack_public_path__ + "static/media/onboardingStage.abae31dffe296c6b3944e84710e1d72b.svg";
export { ForwardRef as ReactComponent };